export default "/_next/static/a9c8abcb414ff68eeffc6f77ebf7a1c0.jpg";